import React from "react";

// Organic top wave divider
export function WaveTop({ color = "#FFF9EE", className = "" }) {
  return (
    <div className={`w-full overflow-hidden leading-[0] ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className="w-full h-[60px] sm:h-[90px]">
        <path fill={color} d="M0,32 C240,88 480,0 720,24 C960,48 1200,96 1440,40 L1440,90 L0,90 Z" />
      </svg>
    </div>
  );
}

export function WaveBottom({ color = "#FFF9EE", className = "" }) {
  return (
    <div className={`w-full overflow-hidden leading-[0] ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className="w-full h-[60px] sm:h-[90px]">
        <path fill={color} d="M0,58 C240,2 480,90 720,66 C960,42 1200,-6 1440,50 L1440,0 L0,0 Z" />
      </svg>
    </div>
  );
}

export function Blob({ className = "", color = "#FFD447" }) {
  return (
    <svg className={className} viewBox="0 0 200 200" aria-hidden="true">
      <path fill={color} d="M42,-62C56,-53,69,-42,74,-28C79,-14,76,3,68,17C60,31,47,41,34,50C21,59,7,66,-9,68C-25,70,-42,66,-55,55C-68,44,-77,26,-79,7C-81,-12,-77,-32,-66,-46C-55,-60,-37,-68,-19,-72C-1,-76,17,-71,42,-62Z" transform="translate(100 100)" />
    </svg>
  );
}
